import React from 'react';
import './CTAButton.scss';
import PlayTriangle from '../../Icons/PlayTriangle';
import { COLORS } from '../../../../constants/colors';

/**
 * Renders a CTA button
 * @param {('primary'|'secondary'|'pdp-hero')} type
 * @param {string} link - the cta link
 * @param {string} text - the cta text
 * @param {('_blank'|'_self')} target - external vs internal link
 * @param {string} additionalClasses - any additional classes
 * @param {string} name - if its a button, the buttons name
 * @param {string} ariaLabel - if its a button, the aria-label
 * @param {boolean} disabled - if its a button, is it disabled
 * @param {boolean} isButton
 * @param {function} onClick - if its a button, the onClick action
 * @param {string} buttonType
 * @returns {JSX.Element}
 * @constructor
 */
const CTAButton = ({
  type,
  link,
  text,
  target,
  additionalClasses,
  name = '',
  ariaLabel = '',
  disabled = false,
  isButton = false,
  onClick = null,
  buttonType = '',
  isPlay = false,
}) => {
  const getTheChildren = () =>
    isPlay ? (
      <>
        <PlayTriangle color={COLORS.blue} /> {text}
      </>
    ) : (
      text
    );

  return !isButton ? (
    <a
      className={`c-cta-button ${type} ${additionalClasses}`}
      href={link}
      target={target}
      rel={`${target === '_blank' ? 'noopener noreferrer' : ''}`}
    >
      <span
        className={`${
          type === 'primary' ? 'color-white' : type === 'secondary' ? 'color-black' : 'color-blue'
        }`}
      >
        {text}
      </span>
    </a>
  ) : (
    <button
      className={`c-cta-button ${type} ${additionalClasses}`}
      name={name}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={onClick}
      type={buttonType}
    >
      <span
        className={`${
          type === 'primary' ? 'color-white' : type === 'secondary' ? 'color-black' : 'color-blue'
        }`}
      >
        {getTheChildren()}
      </span>
    </button>
  );
};

export default CTAButton;
